<template>
  <AuthShell
    title="Confirm Email"
    subtitle="Finish setting up your Filmsomniac account."
    :show-hero="false"
  >
    <div class="auth-panel__section">
      <h2 class="auth-panel__title" data-testid="confirm-email-title">{{ title }}</h2>
      <p class="auth-panel__helper" data-testid="confirm-email-message">{{ message }}</p>
    </div>

    <div v-if="isLoading" class="auth-panel__section">
      <p class="auth-secondary">Confirming your email address…</p>
    </div>

    <div v-else class="auth-actions">
      <a class="auth-submit" data-testid="confirm-email-login" href="/login">Login</a>
    </div>
  </AuthShell>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import AuthShell from '../components/AuthShell.vue'

const route = useRoute()
const isLoading = ref(true)
const isConfirmed = ref(false)
const errorMessage = ref('')

const title = computed(() => {
  if (isLoading.value) {
    return 'Confirming email'
  }
  return isConfirmed.value ? 'Email confirmed' : 'Email confirmation failed'
})

const message = computed(() => {
  if (isLoading.value) {
    return 'Please wait while your email address is confirmed.'
  }
  if (isConfirmed.value) {
    return 'Your email address has been confirmed. You can now log in.'
  }
  return errorMessage.value || 'This confirmation link is invalid or has expired.'
})

onMounted(async () => {
  try {
    const resp = await fetch(
      `/api/v1/auth/confirm-email/${route.params.uidb64}/${route.params.token}`
    )
    if (!resp.ok) {
      const data = await resp.json().catch(() => ({}))
      errorMessage.value = data.detail || 'This confirmation link is invalid or has expired.'
      return
    }
    isConfirmed.value = true
  } catch (e) {
    errorMessage.value = 'Network error. Please try again.'
  } finally {
    isLoading.value = false
  }
})
</script>
